module.exports = __webpack_public_path__ + "img/focus-on-bg.65a97d75.png";